import AnalyticsManager from './AnalyticsManager';
import EventParameterKey from './EventParameterKey';

export const triggerPermissionsEvent = (eventName, permissionName, source) => {
  AnalyticsManager.logEvent(eventName, {
    [EventParameterKey.PERMISSION_NAME]: permissionName,
    [EventParameterKey.SOURCE]: source,
  });
};
